export default {
  companySettingsMetadata: {
    fixateChangesButton: 'Зафиксировать изменения',
    fixateChangesCaption: 'Последние изменения не зафиксированы',
    modulesButton: 'Узнать подробнее и подключить',
    licenseStart: 'Дата начала лицензии',
    licenseEnd: 'Дата окончания лицензии',
    maxEmployeeNumber: 'Разрешенное количество сотрудников',
    unlimited: 'Без ограничений',
    licenseNotificationEmails: 'Email для уведомлений об окончании срока действия лицензии',
    licenseNotificationEmailsTooltip:
      'Укажите email-адреса получателей уведомлений. Система автоматически отправляет письма за 14 дней до окончания срока действия лицензии и через 1 день после его окончания.',
    licenseNotificationEmailsHint:
      'Укажите email-адреса через запятую. Если поле пустое — уведомления отправляться не будут',
    banEmployees: 'Вы можете заблокировать всем сотрудникам возможность авторизоваться.',
    hideSelfTesting: 'Выключить самооценку',
    hideFeed: 'Выключить ленту',
    noModules: 'Нет доступных модулей',
    titleExport: 'Выгрузить результаты логирования',
    period: 'Выберите период логирования, по которому хотите получить выгрузку:',
    dateFrom: 'с',
    dateTo: 'по',
    confirmBanEmployees: {
      block: {
        title: 'Заблокировать?',
        text: 'Все сотрудники компании будут заблокированы',
        button: 'Да, заблокировать',
      },
      unblock: {
        title: 'Разблокировать?',
        text: 'Все сотрудники компании будут разблокированы',
        button: 'Да, разблокировать',
      },
    },
    progress: {
      block: {
        title: 'Выполняется блокировка сотрудников',
      },
      unblock: {
        title: 'Выполняется разблокировка сотрудников',
      },
    },
    successMessages: {
      changeSettings: 'Настройки успешно изменены',
      blockEmployees: 'Все сотрудники компании заблокированы',
      unblockEmployees: 'Все сотрудники компании разблокированы',
    },
    errorMessages: {
      changeSettings: 'Не удалось изменить настройки',
      hideSelfTesting: 'Не удалось изменить настройки самооценки',
      hideFeed: 'Не удалось изменить настройки ленты',
      blockEmployees: 'Не удалось заблокировать сотрудников',
      unblockEmployees: 'Не удалось разблокировать сотрудников',
      getRecordTypes: 'Не удалось получить список типов логирования',
      getBanEmployees: 'Не удалось получить статус блокировки сотрудников',
    },
  },
};
